import { ProvideNames } from '#shared/statics';
import { useBroadcastChannel, useVibrate } from '@vueuse/core'
import { fetchNavigationTree, getExpNavigationTree } from './ExpApi/expCache';
import { initializeCartStates } from './shoppingCartApi';

export const clickAnchorForAccordionPanel = ($event: MouseEvent, navId?: string) => {
	const target = $event.target as HTMLAnchorElement;
	let id: string = navId || '';
	if (id === '') {
		if (target.href && target.href.split("#").length > 1) {
			id = target.href.split("#")[1];
		}
	}
	if (id !== "") {
		const element = document.getElementById(id);
		if (element) {
			element.dispatchEvent(
				new CustomEvent("customOpen", {
					bubbles: false,
				})
			);
		}
	}
	return true;
};

export const useReactiveSearchCreds = () => {
	return {
		reactiveBaseAppName: useRuntimeConfig()?.public?.reactiveBaseAppName,
		reactiveBaseAppUser: useRuntimeConfig()?.public?.reactiveBaseAppUser,
		reactiveBaseAppPassword: useRuntimeConfig()?.public?.reactiveBaseAppPassword,
		reactiveBaseSuggestName: useRuntimeConfig()?.public?.reactiveBaseSuggestName,
	};
};

export const useEasterEgg = (eggName: string) => {
	onNuxtReady(() => {
		if (eggName == 'einruckeln') {
			function wackeln() {
				const x = Math.floor(Math.random() * 10) - 5;
				const y = Math.floor(Math.random() * 10) - 5;
				document.body.style.transform = `translate(${x}px, ${y}px)`;
			}
			const wackelnInterval = setInterval(wackeln, 50);
			const { vibrate, stop, isSupported } = useVibrate({ pattern: [300, 100, 300, 500, 300, 100, 300, 500, 300, 100, 300] })
			// Start the vibration, it will automatically stop when the pattern is complete:
			if (isSupported) {
				vibrate()
			}
			setTimeout(() => {
				clearInterval(wackelnInterval);
				document.body.style.transform = `translate(0px, 0px)`;
			}, 15000);
		} else if (eggName == 'btdev') {
			useUserGroup().value = 'internal'
			setABContextVariable('usergroup', 'internal');
		} else if (eggName == 'pride') {
			const header = document.querySelector('.sticky-header');
			header.style.background = 'linear-gradient(rgb(228,3,3) 0%, rgb(228,3,3) 16%, rgb(255,140,0) 16%, rgb(255,140,0) 32%, rgb(255,237,0) 32%, rgb(255,237,0) 48%, rgb(0,128,38) 48%, rgb(0,128,38) 64%, rgb(0,77,255) 64%, rgb(0,77,255) 80%, rgb(117,7,135) 80%, rgb(117,7,135) 100%) 0px 0px / 100% 200%';
			header.style.animation = `eggAnimation 2s linear infinite reverse`;
		}
	})
}

export const getApiUrl = () => {
	return import.meta.client ? useRuntimeConfig()?.public?.apiUrl : '';
}

export const switchToCentralStore = async (updateFunction: any) => {
	try {
		console.log("change store event");
		useStoreCookie().value = "e_2879130";

		const csrfToken = await $fetch("/api/neo/frontend/_api/user/getCsrfToken?campaignid=", {
			method: "GET",
		});
		await $fetch('/api/switchStore?branch_id=e_2879130', {
			headers: {
				'csrf-token': csrfToken?.csrfToken
			}
		});
		updateFunction("e_2879130");
		console.log("update function called");
		await navigateTo("/shop/unsere-produkte/tv-audio?campaignID", { external: true });
	} catch (error) {
		console.warn("could not change store");
	}
}

export function sendBeacon(ping) {
	try {
		if (ping && typeof ping == 'string' && !ping.includes('undefined'))
			new Image().src = ping;
	} catch (error) {
		console.warn('could not phone home', error);
	}
}

export const getStoreIdBySlug = async (storeSlug: string): Promise<string> => {
	const data = await getStoreIdOrNullBySlug(storeSlug);
	if (data !== null) {
		return data;
	} else {
		return ProvideNames.DEFAULT_CENTRAL_STORE.id;
	}
};

export const getStoreIdOrNullBySlug = async (storeSlug: string): Promise<string | null> => {
	const { data: storeData } = await useFetch('/api/neo/store', { query: { urlPart: storeSlug } });
	if (
		storeData?.value?.searchResults
		&& Array.isArray(storeData.value.searchResults)
		&& storeData.value.searchResults.length > 0
		&& storeData.value.searchResults[0]?.id
	) {
		useLogger('storeInitializer').info(`StoreSlug found store: ${storeData.value.searchResults[0].id}`);
		return storeData.value.searchResults[0].id;
	} else {
		return null;
	}

}

export const changeToStoreById = async (newId: string, oldId?: string, reason?: string) => {
	const toNewId = newId?.startsWith('e_')	? newId : ('e_' + newId)
	const logger = useLogger('changeStoreById');

	const { isSupported, post } = useBroadcastChannel({ name: 'fmarkt-channel' });
	if (!oldId) {
		oldId = useCurrentStore()?.value?.id
	}

	logger.debug("[bt-default] store changed event");
	logger.debug("[bt-default] found " + useStoreCookie()?.value + " in cookie vs " + toNewId);

	await useGeneralTrick({
		eventType: 'STORE_CHANGE',
		sessionId: useCurrentUserState()?.value?.sessionIdentifier || useCurrentSessionIdentifier()?.value,
		json: {
			reason: reason || 'unknown',
			from: oldId,
			to: toNewId
		}
	});

	await clearNuxtState([
		'currentShoppingCart',
		'currentReservationCart',
		'navigation_treeMAIN',
		'navigation_treeSUPER',
		'navigation_treeFOOTER'
	]);

	await useFetch('/api/switchStore?branch_id=' + toNewId, {
		deep: true
	});
	const { data: newStore } = await useFetch('/api/store', { query: { storeId: toNewId } });
	const oldStoreId: string = useCurrentStore()?.value?.storeId;
	refreshCookie(ProvideNames.STORE_COOKIE_NAME);
	if (oldStoreId !== newStore?.value?.storeId) {
		await nextTick(() => {
			useCurrentStore().value = newStore?.value;
			refreshCookie(ProvideNames.STORE_COOKIE_NAME);
		})
	} else {
		if (useStoreCookie().value != newStore?.value?.id)
			console.warn('store not changed in cookie', newStore?.value, useStoreCookie().value);
	}

	getExpNavigationTree('MAIN').data.value = await fetchNavigationTree('MAIN');
	getExpNavigationTree('SUPER').data.value = await fetchNavigationTree('SUPER');
	getExpNavigationTree('FOOTER').data.value = await fetchNavigationTree('FOOTER');
	getExpNavigationTree('FOOTER_HARDLINKS').data.value = await fetchNavigationTree('FOOTER_HARDLINKS');
	getExpNavigationTree('FOOTER_SOCIAL').data.value = await fetchNavigationTree('FOOTER_SOCIAL');

	await initializeCartStates();

	if (!useState('currentShoppingCart')?.value) {
		useState('shoppingCartItemsCount').value = 0;
	}
	if (!useState('currentReservationCart')?.value) {
		useState('reservationCartItemsCount').value = 0;
	}

	if (isSupported?.value) {
		post(toNewId);
	}
}

export const changeStoreById = async (newId: string, oldId?: string, reason?: string) => {
	const toNewId = newId?.startsWith('e_')	? newId : ('e_' + newId)
	const rout = useRoute()?.fullPath?.toLowerCase();
	const hasCampaignID = Object.keys(useRoute()?.query ?? {})?.filter(para => para?.toLowerCase() == 'campaignid')?.length > 0;
	if (hasCampaignID || rout.includes('branch_id')) {
		const cleanQuery = { ...useRoute().query }
		Object.keys(cleanQuery).forEach(param => {
			if (param?.toLowerCase() == 'campaignid' || param?.toLowerCase() == 'branch_id') {
				delete cleanQuery[param];
			}
		})
		console.debug('got cleaned up query', cleanQuery, { query: cleanQuery, path: useRoute().path })
		await navigateTo({ query: cleanQuery, path: useRoute().path, force: true });
	}
	await changeToStoreById(toNewId, oldId, reason);
}


export async function getFeature(feature: string) {
	const { data } = await useFetch('/api/neo/getFeatures', {
		query: {
			type: feature
		}
	});
	return data
}

export function sendToAppStore() {
	useState('showRatingRationale').value = false;
	useAppSettingsCookie().value.hasAskedForRating = true;
	if (useDevice()?.isApple) {
		return navigateTo('https://itunes.apple.com/app/id6484269442?action=write-review', { external: true, open: { target: "_blank" } })
	} else {
		return navigateTo('market://details?id=de.expert.brntgs.app.twa', { external: true, open: { target: "_blank" } })
	}
}
export function sendAppFeedback() {
	useState('showRatingRationale').value = false;
	useAppSettingsCookie().value.hasAskedForRating = true;
	return navigateTo('https://www.expert.de/Footer/Service/AppFeedback', { external: true, open: { target: "_blank" } })
}